import { createContext } from 'react';

import { GameDifficulty } from 'graphql/types';

import useMatchmaking, { MatchmakingData } from '../hooks/useMatchmaking';

export const StartMatchContext = createContext<MatchmakingData>({
  loading: false,
  allowCpuMatch: false,
  startMatchmaking: () => {},
  stopMatchmaking: () => {},
});

interface Props {
  children: React.ReactNode | null;
  gameDifficulty: GameDifficulty;
}

export const StartMatchProvider = ({ children, gameDifficulty }: Props) => {
  const {
    startMatchmaking,
    stopMatchmaking,
    error,
    data,
    loading,
    allowCpuMatch,
    opponent,
  } = useMatchmaking({ gameDifficulty });

  return (
    <StartMatchContext.Provider
      value={{
        startMatchmaking,
        stopMatchmaking,
        error,
        data,
        loading,
        allowCpuMatch,
        opponent,
      }}
    >
      {children}
    </StartMatchContext.Provider>
  );
};
